module.exports = __webpack_public_path__ + "assets/61ef609d67a691b07333e89b4521174e.json";